module.exports = __webpack_public_path__ + "img/projectManagementLogo.de0e76a.svg";